import {parseError} from '@application/PromoCode/ParsePromoCodeError';
import {PromoCode} from '@domain/model/Account/PromoCode/PromoCode';
import {BalanceRepository} from '@modules/balance/core/domain/BalanceRepository';

const RedeemBalance =
  (repository: BalanceRepository) =>
  (balanceCode: string, device: string): Promise<PromoCode> =>
    repository.redeemBalance(balanceCode, device).catch(parseError);

export {RedeemBalance};
